import { render, staticRenderFns } from "./04.vue?vue&type=template&id=a706b6b0&"
import script from "./04.vue?vue&type=script&lang=js&"
export * from "./04.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports